import { Action } from 'redux';
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions';
import { ChatRequest, ChatResponse } from 'src/common/models/chat';
import * as Actions from './actionTypes';

export interface SendChatMessageAction extends Action {
    request: ChatRequest
}

export interface SendChatMessageSuccessAction extends Action {
    request: ChatRequest
    response: ChatResponse
}

export const cleanChat = (): Action => ({
    type: Actions.CLEAN_CHAT,
})

export const sendChatMessageApi = (request: ChatRequest): SendChatMessageAction => ({
    type: Actions.SEND_CHAT_MESSAGE_API,
    request,
})

export const sendChatMessageApiSuccess = (request: ChatRequest, response: ChatResponse): SendChatMessageSuccessAction => ({
    type: Actions.SEND_CHAT_MESSAGE_API_SUCCESS,
    request,
    response,
})

export const sendChatMessageApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.SEND_CHAT_MESSAGE_API_ERROR,
    error,
)
